import { lazy } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from 'react-router-dom';
import { RequireUser } from 'features/authentication/requireUser';
import { Login } from 'pages/login';
import { ROUTES } from 'shared/constant/routes';
import { Layout } from 'widgets/layout';

const TasksPage = lazy(() => import('./tasks'));
const TaskAddPage = lazy(() => import('./taskAdd'));
const TaskEditPage = lazy(() => import('./taskEdit'));
const TaskView = lazy(() => import('./taskView'));
const TaskMore = lazy(() => import('./taskMore'));
const EmployeesPage = lazy(() => import('./employees'));
const MachineryPage = lazy(() => import('./machinery'));
const UnitsPage = lazy(() => import('./units'));
const FarmlandsPage = lazy(() => import('./farmlands'));
const FarmlandsAddPage = lazy(() => import('./farmlandsAdd'));
const FarmlandsEditPage = lazy(() => import('./farmlandsEdit'));
const NoMatchPage = lazy(() => import('./noMatch'));
const MonitoringPage = lazy(() => import('./monitoring/ui/Monitoring'));
const StatisticPage = lazy(() => import('./statistic/ui/Statistic'));
const DevicesPage = lazy(() => import('./devices/ui/Devices'));
const DeviceAddPage = lazy(() => import('./deviceAdd/ui/DeviceAdd'));
const DeviceEditPage = lazy(() => import('./deviceEdit/ui/DeviceEdit'));
const CalibrationsPage = lazy(() => import('./calibrations/ui/Calibrations'));
const CalibrationAddPage = lazy(
  () => import('./calibrationAdd/ui/CalibrationAdd'),
);
const CalibrationEditPage = lazy(
  () => import('./calibrationEdit/ui/CalibrationEdit'),
);

export const appRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path={ROUTES.APP}
        element={<Navigate to={ROUTES.MONITORING} replace />}
      />

      <Route path={ROUTES.APP} element={<Layout />}>
        <Route element={<RequireUser />}>
          <Route index path={ROUTES.MONITORING} element={<MonitoringPage />} />
          <Route index path={ROUTES.TASKS} element={<TasksPage />} />
          <Route path={ROUTES.TASKS_ADD} element={<TaskAddPage />} />
          <Route path={ROUTES.TASKS_EDIT} element={<TaskEditPage />} />
          <Route path={ROUTES.TASKS_VIEW} element={<TaskView />} />
          <Route path={ROUTES.TASKS_MORE} element={<TaskMore />} />
          <Route path={ROUTES.EMPLOYEES} element={<EmployeesPage />} />
          <Route path={ROUTES.MACHINERY} element={<MachineryPage />} />
          <Route path={ROUTES.UNITS} element={<UnitsPage />} />
          <Route path={ROUTES.FARMLANDS} element={<FarmlandsPage />} />
          <Route path={ROUTES.FARMLANDS_ADD} element={<FarmlandsAddPage />} />
          <Route path={ROUTES.FARMLANDS_EDIT} element={<FarmlandsEditPage />} />
          <Route path={ROUTES.STATISTIC} element={<StatisticPage />} />
          <Route path={ROUTES.DEVICES} element={<DevicesPage />} />
          <Route path={ROUTES.DEVICES_ADD} element={<DeviceAddPage />} />
          <Route path={ROUTES.DEVICES_EDIT} element={<DeviceEditPage />} />
          <Route path={ROUTES.CALIBRATIONS} element={<CalibrationsPage />} />
          <Route
            path={ROUTES.CALIBRATION_ADD}
            element={<CalibrationAddPage />}
          />
          <Route
            path={ROUTES.CALIBRATION_EDIT}
            element={<CalibrationEditPage />}
          />
          <Route path="*" element={<NoMatchPage />} />
        </Route>
      </Route>

      <Route path={ROUTES.LOGIN} element={<Login />} />
    </>,
  ),
);
